export default __webpack_public_path__ + "static/media/Girdle of the Refectory.5b1d7733.jpg";